export default {
    computed: {
        currentLocale() {
            return this.$page.props.locale;
        },
    },
};
